import type React from 'react';

import { Button, ProfileCard, Text } from '@change/ds-core-ui';
import { CheckmarkVerifiedIcon, DecisionMakerIcon } from '@change/ds-icons';

import { Translate, TranslatePlural, useI18n } from '@change-corgi/core-react/i18n';

import { useDecisionMakerCard } from './hooks/useDecisionMakerCard';

export const DecisionMakerCard: React.FC<EmptyProps> = () => {
	const {
		data: { decisionMaker },
		actions: { trackClick },
	} = useDecisionMakerCard();
	const { translate } = useI18n();

	if (!decisionMaker) return null;

	return (
		<ProfileCard
			data-qa="search-dm-card"
			orientation="horizontal"
			className="border-stroke-weaker mb-4 w-full max-w-none! border md:mb-6"
			href={decisionMaker.profileUrl}
			onNameClick={() => trackClick('name')}
			name={
				<span className="inline-flex items-center gap-2">
					{decisionMaker.name}
					{decisionMaker.verified && (
						<CheckmarkVerifiedIcon
							size="small"
							className="text-icon-information"
							aria-label={translate('corgi.search.decision_maker_card.verified')}
							data-testid="search-dm-card-verified"
						/>
					)}
				</span>
			}
			// the name is right next to it, so the avatar is decorative
			imgAlt=""
			userRole={decisionMaker.title}
			avatar={decisionMaker.avatarUrl}
			icon={<DecisionMakerIcon />}
			iconPosition="right"
			label={
				<Text as="p" variant="body" size="small" className="text-typography-weak">
					<TranslatePlural
						value="corgi.search.decision_maker_card.label"
						count={decisionMaker.petitionsCount}
						replacements={{ countLocalized: decisionMaker.petitionsCountLocalized }}
					/>
				</Text>
			}
		>
			<Button
				as="a"
				href={decisionMaker.profileUrl}
				variant="secondary"
				size="small"
				className="self-start max-md:w-full!"
				data-qa="search-dm-card-view-profile"
				onClick={() => trackClick('view_profile')}
			>
				<Translate value="corgi.search.decision_maker_card.view_profile" />
			</Button>
		</ProfileCard>
	);
};
